import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import './no-permissions-panel.scss';
import ForbiddenPage from '../../pages/errors/scenes/ForbiddenPage/forbidden-page'

class NoPermissionsPanel extends React.Component {

    constructor(Props) {
        super(Props);

        this.state = {

        }
    }

    //type can either be project, projects, task, tasks

    render = () => {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} className="admin-permission-warning-panel">
                <Modal.Body className="project-creation-popup">
                    <ForbiddenPage />
                    <Button className="btn-large" onClick={this.props.onHide}>OK</Button>
                </Modal.Body>
            </Modal>
        )
    }
                        
}

export default NoPermissionsPanel;